import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL || "https://test.avistha.com/api";
const api = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
  timeout: 15000,
});

// Attach auth token to every request
api.interceptors.request.use((config) => {
  const stored = localStorage.getItem("hc_user");
  if (stored) {
    try {
      const { token } = JSON.parse(stored);
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch {}
  }
  return config;
});

// Global response error handling
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("hc_user");
      window.location.href = "/login";
    }
    return Promise.reject(
      error.response?.data || { message: "Something went wrong" }
    );
  }
);

export default api;
